module.exports = __webpack_public_path__ + "static/Prof.IsmailHadisoebrotoDilogoMDPhD-792836c0a14e6887b2f996b184bebc69.jpg";